import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  {
    class: 'ineligible',
    field: 'womenHairLoss_ineligible',
    label: "We're sorry you don't qualify",
    subLabel: "We're not able to prescribe for you today",
    educationalSlide: '',
    extras: { sendToBeluga: false },
    blockQuestionFlow: true,
    type: 'info',
    isLast: true,
    answer: {}
  },
  {
    field: 'womenHairLoss_complete',
    isLast: true,
    label: `Thank you for completing this questionnaire, please select "Finish" to submit`,
    extras: { sendToBeluga: false },
    type: 'info',
    answer: {}
  },
  {
    label: 'What was your sex assigned at birth?',
    field: 'womenHairLoss_sexAssignedAtBirth',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'womenHairLoss_sexAssignedAtBirth_male',
          value: 'Male'
        },
        {
          key: 'womenHairLoss_sexAssignedAtBirth_female',
          value: 'Female'
        }
      ]
    }
  },
  {
    label:
      'Are you currently pregnant, breastfeeding or planning to become pregnant?',
    field: 'womenHairLoss_pregnancy',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'womenHairLoss_pregnancy_yes',
          value: 'Yes'
        },
        {
          key: 'womenHairLoss_pregnancy_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Consent (pregnancy):',
    educationalSlide: `
    I understand that the medication prescribed to me by my healthcare provider may not be safe to take during pregnancy. For example, medications which contain finasteride are known to cause significant birth defects in a fetus and child. I acknowledge that taking this medication while pregnant could pose risks to my health and the health of a developing fetus.
    
    I agree to take necessary precautions to avoid becoming pregnant while using this medication, including the use of effective contraception methods as discussed with my healthcare provider.
    
    I understand that I should stop taking this medication before attempting to become pregnant. I agree to consult with my healthcare provider prior to discontinuing the medication and before planning a pregnancy to ensure my safety and well-being.
    
    By selecting below, I confirm that I have read and understand the information provided above. I consent to proceed with the treatment under these conditions.
    `,
    field: 'womenHairLoss_consentPregnancy',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'womenHairLoss_consentPregnancy_disagree',
          class: 'option-decline',
          value: 'I have read the information and do NOT wish to proceed'
        },
        {
          key: 'womenHairLoss_consentPregnancy_agree',
          class: 'option-consent',
          value:
            'I have read and understand the above information, I understand the risks and wish to proceed'
        }
      ]
    }
  },
  {
    label:
      'Are you postmenopausal, meaning you have not had a menstrual period for 12 months or longer?',
    field: 'womenHairLoss_postMenopausal',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'womenHairLoss_postMenopausal_yes',
          value: 'Yes'
        },
        {
          key: 'womenHairLoss_postMenopausal_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'What is your height in feet and inches?',
    field: 'womenHairLoss_height',
    type: 'info',
    answer: {
      name: 'womenHairLoss_height_ans',
      type: 'text',
      placeholder: 'Feet and inches'
    }
  },
  {
    label: 'What is your weight in pounds?',
    field: 'womenHairLoss_weight',
    type: 'info',
    answer: {
      name: 'womenHairLoss_weight_ans',
      type: 'text',
      placeholder: 'Pounds'
    }
  },
  {
    label: 'Please identify all your current medical conditions',
    field: 'womenHairLoss_currentMedicalConditions',
    type: 'info',
    answer: {
      name: 'womenHairLoss_currentMedicalConditions_ans',
      type: 'text',
      placeholder: 'Medical conditions'
    }
  },
  {
    label: 'Please list all your current medications including dosages',
    field: 'womenHairLoss_currentMedications',
    type: 'info',
    answer: {
      name: 'womenHairLoss_currentMedications_ans',
      type: 'text',
      placeholder: 'Medications'
    }
  },
  {
    label: 'Please list all of your known allergies',
    field: 'womenHairLoss_knownAllergies',
    type: 'info',
    answer: {
      name: 'womenHairLoss_knownAllergies_ans',
      type: 'text',
      placeholder: 'Allergies'
    }
  },
  {
    label: 'Which areas are affected by hair loss?',
    field: 'womenHairLoss_affectedAreas',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'womenHairLoss_affectedAreas_recedingHairline',
          value: 'Receding hairline'
        },
        {
          key: 'womenHairLoss_affectedAreas_thinningAtCrown',
          value: 'Thinning at the crown'
        },
        {
          key: 'womenHairLoss_affectedAreas_overallThinning',
          value: 'Overall thinning'
        },
        {
          key: 'womenHairLoss_affectedAreas_other',
          value: 'Other'
        }
      ]
    }
  },
  {
    label: 'Tell us more about the pattern of your hair loss',
    field: 'womenHairLoss_affectedAreas_other_more',
    type: 'info',
    answer: {
      name: 'womenHairLoss_affectedAreas_other_more',
      type: 'text'
    }
  },
  {
    label: 'How long have you been experiencing hair loss?',
    field: 'womenHairLoss_howLongHaveYouBeenExperiencingHairLoss',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'womenHairLoss_howLongHaveYouBeenExperiencingHairLoss_lessThan6Months',
          value: 'Less than 6 months'
        },
        {
          key: 'womenHairLoss_howLongHaveYouBeenExperiencingHairLoss_6MonthsTo1Year',
          value: '6 months to 1 year'
        },
        {
          key: 'womenHairLoss_howLongHaveYouBeenExperiencingHairLoss_over1Year',
          value: 'Over 1 year'
        }
      ]
    }
  },
  {
    label: 'How much hair have you lost?',
    field: 'womenHairLoss_howMuchHairHaveYouLost',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'womenHairLoss_howMuchHairHaveYouLost_aLittle',
          value: 'A little (Only I notice it)'
        },
        {
          key: 'womenHairLoss_howMuchHairHaveYouLost_some',
          value: 'Some (Those close to me notice it)'
        },
        {
          key: 'womenHairLoss_howMuchHairHaveYouLost_aLot',
          value: 'A lot (It is obvious to everyone)'
        }
      ]
    }
  },
  {
    label: ' Do you believe your hair loss is due to:',
    field: 'womenHairLoss_hairLossCause',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'womenHairLoss_hairLossCause_genetics',
          value: 'Genetics'
        },
        {
          key: 'womenHairLoss_hairLossCause_stress',
          value: 'Stress'
        },
        {
          key: 'womenHairLoss_hairLossCause_medicalConditions',
          value: 'Medical conditions'
        },
        {
          key: 'womenHairLoss_hairLossCause_medications',
          value: 'Medications'
        },
        {
          key: 'womenHairLoss_hairLossCause_nutritionalDeficiencies',
          value: 'Nutritional deficiencies'
        },
        {
          key: 'womenHairLoss_hairLossCause_other',
          value: 'Other'
        }
      ]
    }
  },
  {
    label: 'Tell us more about why you think you are losing hair',
    field: 'womenHairLoss_hairLossCause_other_why',
    type: 'info',
    answer: {
      name: 'womenHairLoss_hairLossCause_other_why',
      type: 'text'
    }
  },
  {
    label: 'Have you ever had your hair loss evaluated by a physician?',
    field: 'womenHairLoss_hairlossPhysician',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'womenHairLoss_hairlossPhysician_yes',
          value: 'Yes'
        },
        {
          key: 'womenHairLoss_hairlossPhysician_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Have you ever had your hair loss evaluated by a physician? Please select any of the following diagnoses that you have been given by a physician in the past',
    field: 'womenHairLoss_hairLossEvaluation',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'womenHairLoss_hairLossEvaluation_androgeneticAlopecia',
          value: 'Androgenetic alopecia'
        },
        {
          key: 'womenHairLoss_hairLossEvaluation_alopeciaAreata',
          value: 'Alopecia areata'
        },
        {
          key: 'womenHairLoss_hairLossEvaluation_tractionAlopecia',
          value: 'Traction alopecia'
        },
        {
          key: 'womenHairLoss_hairLossEvaluation_telogenEffluvium',
          value: 'Telogen effluvium'
        },
        {
          key: 'womenHairLoss_hairLossEvaluation_discoidLupus',
          value: 'Discoid Lupus'
        },
        {
          key: 'womenHairLoss_hairLossEvaluation_scarringAlopecia',
          value: 'Scarring Alopecia'
        },
        {
          key: 'womenHairLoss_hairLossEvaluation_frontalFibrosingAlopecia',
          value: 'Frontal Fibrosing Alopecia'
        },
        {
          key: 'womenHairLoss_hairLossEvaluation_other',
          value: 'Other hair loss diagnosis'
        },
        {
          key: 'womenHairLoss_hairLossEvaluation_none',
          uncheckOthers: true,
          value: 'I have not been given a diagnosis'
        }
      ]
    }
  },
  {
    label: 'Please tell us more about your diagnosis',
    field: 'womenHairLoss_hairLossEvaluation_other_diagnosis',
    type: 'info',
    answer: {
      name: 'womenHairLoss_hairLossEvaluation_other_diagnosis',
      type: 'text'
    }
  },
  {
    label:
      'Do you have any scalp conditions such as psoriasis, dermatitis, and/or recent or current scalp infections?',
    field: 'womenHairLoss_scalpConditions',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'womenHairLoss_scalpConditions_yes',
          value: 'Yes'
        },
        {
          key: 'womenHairLoss_scalpConditions_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Do you have excessive dandruff, scalp irritation, scalp redness, burning, pustules, or scarring?',
    field: 'womenHairLoss_scalpIrritation',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'womenHairLoss_scalpIrritation_yes',
          value: 'Yes'
        },
        {
          key: 'womenHairLoss_scalpIrritation_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Are you losing hair in different parts of your body?',
    field: 'womenHairLoss_hairLossInDifferentPartsOfBody',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'womenHairLoss_hairLossInDifferentPartsOfBody_yes',
          value: 'Yes'
        },
        {
          key: 'womenHairLoss_hairLossInDifferentPartsOfBody_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Tell us more about your hair loss in other parts of your body',
    field: 'womenHairLoss_hairLossInDifferentPartsOfBody_more',
    type: 'info',
    answer: {
      name: 'womenHairLoss_hairLossInDifferentPartsOfBody_more',
      type: 'text'
    }
  },
  {
    label: 'Have you tried any treatments for hair loss before?',
    field: 'womenHairLoss_hairLossTreatments',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'womenHairLoss_hairLossTreatments_yes',
          value: 'Yes'
        },
        {
          key: 'womenHairLoss_hairLossTreatments_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Tell us more about your previous treatment including product use, when, duration of use, and did you experience side effects?',
    field: 'womenHairLoss_hairLossTreatments_yes_more',
    type: 'info',
    answer: {
      type: 'text',
      rows: 3,
      name: 'womenHairLoss_hairLossTreatments_yes_more'
    }
  },
  {
    label:
      'Do you have any of the following medical conditions? (check all that apply)',
    field: 'womenHairLoss_medicalConditions',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'womenHairLoss_medicalConditions_liverCirrhosis',
          value: 'Liver disease such as liver cirrhosis'
        },
        {
          key: 'womenHairLoss_medicalConditions_kidneyDisease',
          value:
            'Kidney disease such as chronic kidney disease or kidney failure'
        },
        {
          key: 'womenHairLoss_medicalConditions_heartConditions',
          value: 'Heart conditions or cardiovascular diseases'
        },
        {
          key: 'womenHairLoss_medicalConditions_stroke',
          value: 'History of stroke'
        },
        {
          key: 'womenHairLoss_medicalConditions_pheochromocytoma',
          value: 'Pheochromocytoma (adrenal gland tumor)'
        },
        {
          key: 'womenHairLoss_medicalConditions_pulmonaryHypertension',
          value: 'Pulmonary hypertension'
        },
        {
          key: 'womenHairLoss_medicalConditions_none',
          uncheckOthers: true,
          value: 'None of these apply to me'
        }
      ]
    }
  },
  {
    label:
      'Do you have a history of depression, bipolar disorder, anxiety, or other mood disorders?',
    field: 'womenHairLoss_moodDisorders',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'womenHairLoss_moodDisorders_yes',
          value: 'Yes'
        },
        {
          key: 'womenHairLoss_moodDisorders_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Can you tell us more about your mood disorder and whether it is controlled or uncontrolled?',
    field: 'womenHairLoss_moodDisorders_yes_more',
    type: 'info',
    answer: {
      type: 'text',
      name: 'womenHairLoss_moodDisorders_yes_more'
    }
  },
  {
    label: 'What other information or questions do you have for the doctor?',
    field: 'womenHairLoss_otherInformationOrQuestions',
    type: 'info',
    answer: {
      name: 'womenHairLoss_otherInformationOrQuestions',
      type: 'text',
      placeholder: ''
    }
  },
  {
    label: 'Consent',
    educationalSlide: `    
    To address hair loss in women through various medical interventions aimed at slowing hair loss, promoting new hair growth, and improving hair density and appearance.
    
    Potential Benefits
        - Slowing down the progression of hair loss
        - Stimulating new hair growth
        - Enhancing the thickness and appearance of existing hair
        - Improving self-esteem and quality of life

    Contraindications
    Certain treatments may not be suitable for individuals with:
        - Specific medical conditions (e.g., liver disease, kidney disease)
        - Allergies to medications or their components
        - Pregnancy or breastfeeding
        - Hormonal imbalances
        - Scalp conditions such as dermatitis or psoriasis

    Potential Risks and Side Effects
        - Scalp irritation, itching, or dryness
        - Hormonal changes
        - Unwanted hair growth in unintended areas
        - Electrolyte imbalances
        - Mood changes or depression
        - Allergic reactions
        - Changes in blood pressure or heart rate

    Monitoring and Follow-up
    Regular monitoring is recommended to assess effectiveness and detect any side effects. This may include physical examinations and laboratory tests as deemed necessary by your healthcare provider. Inform your provider of any adverse reactions or concerns.

    Alternative Treatments
        - Hair transplant surgery
        - Low-level laser therapy
        - Platelet-rich plasma (PRP) therapy
        - Lifestyle adjustments and acceptance of hair loss

    Consent for Other Treatments
    By signing this consent form, you agree to the use of medications or treatments as recommended by your healthcare provider for the management of hair loss. All treatments, including those not specifically mentioned above, will be discussed with you, including their potential benefits and risks.

    Patient Responsibilities
        - Use treatments exactly as prescribed
        - Report any side effects promptly
        - Keep all follow-up appointments
        - Inform your provider of any changes in your health status or medications

    By agreeing below, you acknowledge that you have read and understood the information provided in this consent form. You agree to proceed with treatment under the conditions outlined above.
    `,
    field: 'womenHairLoss_consent',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'womenHairLoss_consent_non_consent',
          class: 'option-decline',
          value: 'I have read the above information and do NOT wish to proceed'
        },
        {
          key: 'womenHairLoss_consent_agree',
          class: 'option-consent',
          value:
            'I have read the above information, understand the risks, and wish to proceed.'
        }
      ]
    }
  }
];

export default questionsModels;
